module.exports = __webpack_public_path__ + "static/media/aero2.8eb810f0.jpg";